<template>
  <div class="choose-subscription-plan-review">

    <div class="choose-subscription-column__left">

      <nuttrema-form-alert
         style="margin-bottom: 1em"
        :error="_get(InstanceRegistrationCheckout, 'error')">
      </nuttrema-form-alert>

      <nuttrema-layout-form-standard
         ref="ref-layout-form-standard"
         class="is-payment-form is-section-transparent"
        :edit="true"
        :theme="theme">

        <template slot="center">
          <el-form
             label-width="15em"
            :ref="formRef"
            :rules="rules"
            :model="formData"
            :validate-on-rule-change="false"
            :label-position="labelPosition">

            <resize-observer @notify="onResize"></resize-observer>

            <section>
              <div class="section-title">{{ isTrial ? $t('label.basic_information') : $t('label.payment_information') }}</div>

              <div class="section-items">
                <el-form-item :label="$t('label.email')" class="el-form-item--w-50" prop="email">
                    <el-input v-model="formData.email" disabled></el-input>
                </el-form-item>

                <el-form-item :label="$t('label.owner_name')" class="el-form-item--w-50" prop="owner_name">
                  <el-input v-model="formData.owner_name" :placeholder="$t('label.type_in_your_full_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('label.phone')" class="el-form-item--w-50" prop="phone">
                  <el-input v-model="formData.phone" :placeholder="$t('label.phone_format_placeholder')"></el-input>
                </el-form-item>

                <template v-if="!isTrial">
                  <el-form-item :label="$t('label.professional_id')" class="el-form-item--w-30">
                      <el-input v-model="formData.PersonData.licence_professional_id.value"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('label.vat_number')" class="el-form-item--w-30">
                      <el-input v-model="formData.InstanceData.company_information_vat_number.value"></el-input>
                  </el-form-item>

                  <el-form-item
                     prop="payment_plan_id"
                     class="el-form-item--w-50"
                    :label="$t('label.payment_plan')">
                    <el-input :value="`${_get(SubscriptionReview, 'data.SubscribedPlan.PaymentPlan.name', '')} (${$t('label.months_number', { months: _get(SubscriptionReview, 'data.SubscribedPlan.PaymentPlan.months', 0) }) })`" disabled></el-input>
                  </el-form-item>
                </template>
                <!-- end ~ if not trial -->

              </div>
            </section>

            <section v-if="!isTrial">
              <div class="section-title">{{ $t('label.payment_method') }}</div>

              <div class="section-items is-small-padding">
                <el-collapse v-model="formData.payment_method" accordion @change="onPaymentMethodChange">
                  <el-collapse-item :title="$t('label.credit_card')" name="stripe_source">
                    <el-form-item :label="$t('label.card')" class="el-form-item--w-50" prop="card">
                      <card
                         class="stripe-card"
                        :class="{ 'complete': stripe.complete, 'is-active': stripe.focus }"
                        :stripe="stripe.key"
                        :options="stripe.options"
                        @change="creditCardChanged"
                        @focus="stripeCardFocus"
                        @blur="stripeCardBlur">
                      </card>
                    </el-form-item>

                    <el-form-item :label="$t('label.billing_address')">
                      <el-row>
                        <el-col :span="18">
                          <el-input v-model="formData.PersonData.address_street.value" :placeholder="$t('label.street')"></el-input>
                        </el-col>
                        <el-col :span="5" :offset="1">
                          <el-input v-model="formData.PersonData.address_house_no.value" :placeholder="$t('label.house_no')"></el-input>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="9">
                          <el-input v-model="formData.PersonData.address_city.value" :placeholder="$t('label.city')"></el-input>
                        </el-col>
                        <el-col :span="4" :offset="1">
                          <el-form-item prop="PersonData.address_zip.value">
                            <el-input v-model="formData.PersonData.address_zip.value" :placeholder="getPlaceholderText($t('label.zip'))"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="9" :offset="1">
                          <el-form-item prop="region_id">
                            <el-cascader
                               v-model="formData.region_id"
                               class="w-100"
                              :clearable="true"
                              :filterable="true"
                              :placeholder="getPlaceholderText($t('label.country'))"
                              :options="_get(RegionalAndLanguageAll, 'data.Regions', [])"
                              :props="{ label: 'title', value: 'id', children: 'SubRegions' }"
                              :show-all-levels="false">
                            </el-cascader>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form-item>

                    <el-form-item
                       prop="auto_renewal"
                      :label="getPlaceholderText($t('label.auto_renewal'))">
                      <el-switch v-model="formData.auto_renewal" active-color="#ffdd57"></el-switch>
                    </el-form-item>

                    <el-form-item>
                      <div class="el-form-item__help" style="padding: 0">
                        <div class="powered_by_stripe__logo"></div>
                      </div>
                      <p class="el-form-item__help" style="padding: 0 0.25em">
                        {{ $t('label.stripe_pci_note') }}
                        <br/>
                        <a href="https://stripe.com/docs/security/stripe" target="_blank" ref="no-follow">{{ $t('label.more_info') }}</a>
                      </p>
                    </el-form-item>

                  </el-collapse-item>

                  <el-collapse-item :title="$t('label.bank_transfer')" name="bank_transfer">
                    <el-form-item prop="region_id" class="el-form-item--w-60" :label="$t('label.country')">
                      <el-cascader
                         v-model="formData.region_id"
                         class="w-100"
                        :clearable="true"
                        :filterable="true"
                        :placeholder="getPlaceholderText($t('label.country'))"
                        :options="_get(RegionalAndLanguageAll, 'data.Regions', [])"
                        :props="{ label: 'title', value: 'id', children: 'SubRegions' }"
                        :show-all-levels="false">
                      </el-cascader>
                    </el-form-item>
                    <el-form-item>
                      <p style="line-height: 1.75; font-weight: bold; margin-left: 0.25em; margin-top: 1em; margin-bottom: 0.5em">{{ $t('label.bank_transfer_instructions') }}</p>
                      <p style="line-height: 1.75; margin-left: 0.25em">
                        {{ $t('label.bank_transfer_instruction_help_01') }}<br/>
                        <strong>{{ $t('label.bank_transfer_instruction_help_02') }}</strong><br/>
                        <strong>{{ $t('label.bank_transfer_instruction_help_03') }}</strong><br/>
                        {{ $t('label.bank_transfer_instruction_help_04') }}<br/>
                        {{ $t('label.bank_transfer_instruction_help_05') }}<br/>
                        {{ $t('label.bank_transfer_instruction_help_06') }}<br/>
                        {{ $t('label.bank_transfer_instruction_help_07') }}
                      </p>
                  </el-form-item>
                  </el-collapse-item>
                </el-collapse>
              </div>

              <div class="section-help" v-if="formData.auto_renewal && formData.payment_method !== 'bank_transfer'">
                <p>* {{ $t('label.auto_renewal_help') }}</p>
              </div>
            </section>

          </el-form>
        </template>
      </nuttrema-layout-form-standard>

    </div>
    <!-- end ~ choose-subscription-column__left -->

    <div class="choose-subscription-column__right">
      <div v-sticky class="sticky">
        <subscription-east-summary-review-plan
          :theme="theme"
          :taxRate="taxRate"
          :autoRenewal="formData.auto_renewal"
          :paymentPlanID="_get(SubscriptionReview, 'data.SubscribedPlan.id')"
          :summary="_get(SubscriptionReview, 'data.SubscribedPlan')"
          :processing="processing"
          @previousStep="previousStep"
          @proceedWithPayment="proceedWithPayment">
        </subscription-east-summary-review-plan>
      </div>
    </div>
    <!-- end ~ choose-subscription-column__right -->

  </div>
  <!-- end ~ choose-subscription-plan-review -->
</template>

<script>
/* eslint-disable object-shorthand */
import { get } from 'lodash';
import { ResizeObserver } from 'vue-resize';
import Emitter from 'components/mixins/emitter';

import VueSticky from 'vue-sticky';

import SubscriptionPlanReviewAbstract from 'components/ui/subscription/cmpt-subscription-plan-review-abstract';

import SubscriptionEastSummaryReviewPlan from 'components/ui/subscription/cmpt-subscription-east-summary-review-plan';

export default {
  name: 'cmpt-choose-subscription-plan-review',
  mixins: [
    Emitter,
    SubscriptionPlanReviewAbstract,
  ],
  props: {
    email: {
      required: false,
      default: null,
    },
    theme: {
      required: false,
      default: 'global',
    },
    InstanceRegistrationCheckout: {
      required: false,
      default: null,
    },
  },
  directives: {
    sticky: VueSticky,
  },
  data() {
    return {
      labelPosition: 'right',
    };
  },
  components: {
    ResizeObserver,
    SubscriptionEastSummaryReviewPlan,
  },
  methods: {
    setFormData() {
      this.formData.email = get(this.SubscriptionReview, 'data.Instance.owner_email', null);
    },
    onResize() {
      const form = this.$refs['ref-layout-form-standard'];
      const width = get(form, '$el.clientWidth', 0);
      this.labelPosition = width <= 600 ? 'top' : 'right';
    },
  },
  created() {
    this.formRef = 'form-choose-subscription-plan-review';
    this.$nextTick(() => {
      this.onResize();
    });
  },
  watch: {
    'InstanceRegistrationCheckout.saving': {
      handler: function (newValue) {
        if (!newValue) this.processing = false;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .choose-subscription-plan-review {
    flex-grow: 1;
    display: flex;
    margin-bottom: 2em;
    align-self: stretch;

    .choose-subscription-column__left {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }

    .choose-subscription-column__right {
      display: flex;
      flex: 0 1 300px;
      margin-left: 1em;
      flex-direction: column;
      align-items: flex-start;
      .sticky {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-choose-subscription-plan-review.vue